export default "__VITE_ASSET__DwwHSSI3__"